import { ReactNode } from "react";

import { AccessResult } from "utils/access";
import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import RunPriorityMenu from "components/Run/elements/RunPriorityMenu";
import { RunPriorityPreset } from "types/generated";

import { RunHistoryEntryType } from "../../types";
import styles from "./styles.module.css";

type WorkerPoolEntryWrapperProps = {
  workers: number;
  busyWorkers: number;
  drainedWorkers?: number;
  pendingRuns: number;
  label: ReactNode;
  runId: string;
  stackId: string;
  canPrioritize: AccessResult;
  priorityPreset: RunPriorityPreset;
};

export const WorkerPoolEntryWrapper = ({
  label,
  workers,
  pendingRuns,
  busyWorkers,
  drainedWorkers,
  canPrioritize,
  priorityPreset,
  runId,
  stackId,
}: WorkerPoolEntryWrapperProps) => {
  return (
    <HistoryEntryWrapper state={RunHistoryEntryType.WorkerPool} label={label}>
      <HistoryEntryNote>
        <dl className={styles.list}>
          <dt>All workers</dt>
          <dd>{workers}</dd>
          <dt>Busy</dt>
          <dd>{busyWorkers}</dd>
          {drainedWorkers !== undefined && (
            <>
              <dt>Drained</dt>
              <dd>{drainedWorkers}</dd>
            </>
          )}
          <dt>Pending runs</dt>
          <dd>{pendingRuns}</dd>
        </dl>
      </HistoryEntryNote>
      <RunPriorityMenu
        runId={runId}
        canPrioritize={canPrioritize}
        stackId={stackId}
        priorityPreset={priorityPreset}
      />
    </HistoryEntryWrapper>
  );
};
